import Rails from "@rails/ujs"
const delegate = Rails.delegate.bind(Rails)

delegate(document, '.js-return-submit-disabled', 'keypress', (event: KeyboardEvent) => {
  if (event.key === 'Enter') event.preventDefault()
})
